module.exports = __webpack_public_path__ + "img/sv.0c0da7e5.svg";